'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.PA = exports.BAN = exports.POK = exports.POR = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Zdroj hlavičky platby. Nepovinný, pokud není vyplněný znamená to že platba přišla z ekonomiky/PP.
 */

/**
 * Portál.
 */
var POR = exports.POR = 'POR';

/**
 * Pokladna.
 */
var POK = exports.POK = 'POK';

/**
 * Banka.
 */
var BAN = exports.BAN = 'BAN';

/**
 * Platební automat.
 */
var PA = exports.PA = 'PA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [POR, POK, BAN, PA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, POR, { caption: 'Portál.' }), (0, _defineProperty3.default)(_params, POK, { caption: 'Pokladna.' }), (0, _defineProperty3.default)(_params, BAN, { caption: 'Banka.' }), (0, _defineProperty3.default)(_params, PA, { caption: 'Platební automat.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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